export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
  imageQuery: string;
}

export const categories: Category[] = [
  {
    slug: 'dianying',
    name: '电影',
    description: '精选亚洲各国优质电影，从经典到最新力作',
    icon: 'ri-movie-2-line',
    count: 256,
    imageQuery: 'Cinematic%20Asian%20film%20scene%20with%20dramatic%20lighting%2C%20warm%20golden%20tones%2C%20elegant%20composition%2C%20soft%20background%2C%20artistic%20photography%2C%20minimalist%20aesthetic%2C%20Japanese%20and%20Korean%20cinema%20vibe%2C%20neutral%20cream%20background%2C%20high%20end%20visual%20style'
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    description: '热门亚洲电视剧全集，随时畅享追剧乐趣',
    icon: 'ri-tv-2-line',
    count: 189,
    imageQuery: 'Modern%20Asian%20TV%20drama%20series%20aesthetic%2C%20cozy%20home%20viewing%20setup%2C%20warm%20ambient%20lighting%2C%20elegant%20interior%2C%20soft%20cream%20and%20beige%20tones%2C%20minimalist%20design%2C%20relaxing%20atmosphere%2C%20editorial%20photography%20style'
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    description: '深度探索亚洲文化与自然的纪实影像',
    icon: 'ri-camera-lens-line',
    count: 134,
    imageQuery: 'Nature%20and%20culture%20documentary%20Asian%20scene%2C%20majestic%20landscapes%2C%20warm%20earthy%20tones%2C%20professional%20cinematography%20aesthetic%2C%20clean%20cream%20background%2C%20artistic%20documentary%20film%20style%2C%20soft%20natural%20light'
  },
  {
    slug: 'duanpian',
    name: '短片',
    description: '创意短片与微电影，感受新生代影像力量',
    icon: 'ri-film-line',
    count: 312,
    imageQuery: 'Creative%20short%20film%20Asian%20aesthetic%2C%20artistic%20abstract%20composition%2C%20warm%20minimalist%20background%2C%20modern%20indie%20film%20vibe%2C%20soft%20golden%20and%20cream%20tones%2C%20elegant%20visual%20storytelling%2C%20clean%20design'
  },
  {
    slug: 'dongman',
    name: '动漫',
    description: '亚洲热门动漫作品，经典与新番一网打尽',
    icon: 'ri-ghost-line',
    count: 278,
    imageQuery: 'Anime%20style%20artistic%20illustration%20with%20warm%20tones%2C%20elegant%20Asian%20animation%20aesthetic%2C%20soft%20cream%20background%2C%20Japanese%20anime%20inspired%20visual%2C%20clean%20composition%2C%20modern%20manga%20art%20style%2C%20minimalist'
  },
  {
    slug: 'zongyi',
    name: '综艺',
    description: '精彩亚洲综艺节目，欢笑与感动并存',
    icon: 'ri-emotion-laugh-line',
    count: 156,
    imageQuery: 'Variety%20show%20Asian%20entertainment%20aesthetic%2C%20bright%20warm%20stage%20lighting%2C%20elegant%20show%20production%20style%2C%20cream%20and%20gold%20tones%2C%20clean%20minimalist%20background%2C%20professional%20broadcast%20visual%2C%20soft%20atmosphere'
  },
];